import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const TicketOfferCardContainer = styled("div")(({ theme }) => ({
  position: "relative",
  height: "min-content",
  maxWidth: theme.space._1300,
  flexGrow: 1,
  borderRadius: "1rem",
  overflow: "hidden",
  background: theme.colors["neutral.900"],
  zIndex: 0
}));

export const TicketOfferCardContentContainer = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  alignSelf: "stretch",
  zIndex: 1,
}));

export const TicketOfferExpiresContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  alignSelf: "stretch",
  gap: theme.space._300,
  padding: `${theme.space._500} ${theme.space._800} ${theme.space._600} ${theme.space._800}`,
}));

export const ImageContainer = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  aspectRatio: 1.87,
  width: `calc(100% - 3rem)`
}));

export const TicketHolderContainer = styled("div")<{ isPriority?: boolean }>(({ theme, isPriority }) => ({
  display: "flex",
  height: theme.space._800,
  padding: `0 ${theme.space._500}`,
  alignItems: "center",
  gap: theme.space._200,
  alignSelf: "stretch",
  backgroundImage: `linear-gradient(to left, ${theme.colors["neutral.700"]} 55%, rgba(255,255,255,0) 0%)`,
  backgroundPosition: "bottom",
  backgroundSize: `${theme.space._350} ${theme.space._10}`,
  backgroundRepeat: "repeat-x",
  zIndex: 1,
  color: isPriority ? theme.colors["yellow.300"] : theme.colors["pink.500"],
}));

export const TicketHolder = styled(Typography)(({ theme }) => ({
  color: theme.colors["neutral.50"],
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.lg,
  fontStyle: 'normal',
  fontWeight: theme.fontWeights.semibold,
  lineHeight: theme.lineHeights.base
}));

export const TickerOfferExpirationTypography = styled(Typography)(({ theme }) => ({
  color: theme.colors["neutral.50"],
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.lg,
  fontStyle: 'normal',
  fontWeight: theme.fontWeights.bold,
  lineHeight: theme.lineHeights.slim
}));

export const BadgeContainer = styled("div")(({ theme }) => ({
  marginLeft: "auto",
  display: "flex",
  alignItems: "center",
}));